import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/landOwnership`;

export const createLandOwnership = async (payload) => {
    try {
        const response = await axios.post(API_BASE, payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to create land ownership');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to create land ownership');
        }
    }
};

export const getAllLandOwnershipRecords = async (params = {}) => {
    try {
        const response = await axios.get(API_BASE, { params });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to fetch land ownership records');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to fetch land ownership records');
        }
    }
};

export const getSellers = async (params = {}) => {
    try {
        const response = await axios.get(`${API_BASE}/sellers`, { params });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to fetch sellers');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to fetch sellers');
        }
    }
};

export const getLandOwnershipRecordById = async (id) => {
    try {
        const response = await axios.get(`${API_BASE}/${id}`);
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to fetch land ownership record');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to fetch land ownership record');
        }
    }
};


export const updateLandOwnership = async (id, payload) => {
    try {
        const response = await axios.put(`${API_BASE}/${id}`, payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to update land ownership');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to update land ownership');
        }
    }
};


export const deleteLandOwnership = async (id) => {
    try {
        const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: true }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to delete land ownership');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to delete land ownership');
        }
    }
};


export const restoreLandOwnership = async (id) => {
    try {
        const response = await axios.put(`${API_BASE}/${id}`, { isDeleted: false }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to restore land ownership');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to restore land ownership');
        }
    }
};

const SELLER_LEDGER_API = `${process.env.REACT_APP_API_BASE_URL}/api/sellerLedger`;

export const createSellerLedger = async (payload) => {
    try {
        const response = await axios.post(SELLER_LEDGER_API, payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to create seller ledger entry');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to create seller ledger entry');
        }
    }
};

export const getSellerLedger = async (params = {}) => {
    try {
        const response = await axios.get(SELLER_LEDGER_API, { params });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to fetch seller ledger entries');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to fetch seller ledger entries');
        }
    }
};

export const updateSellerLedger = async (id, payload) => {
    try {
        const response = await axios.put(`${SELLER_LEDGER_API}/${id}`, payload, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            throw new Error(error.response.data?.message || error.response.data?.error || 'Failed to update seller ledger entry');
        } else if (error.request) {
            throw new Error('No response from server. Please check your connection.');
        } else {
            throw new Error(error.message || 'Failed to update seller ledger entry');
        }
    }
};
